import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Heart, Play } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { usePlayer } from "../context/PlayerContext";
import { useT } from "../lib/i18n";
import { MixCard } from "../components/MixCard";
import { SectionTitle } from "../components/Reveal";

export default function Favorites() {
  const { user, openAuth } = useAuth();
  const { withOverrides, playMix } = usePlayer();
  const { t } = useT();
  const [mixes, setMixes] = useState(null);

  useEffect(() => {
    if (!user) return;
    api.get("/me/likes").then((r) => setMixes(Array.isArray(r.data) ? r.data : [])).catch(() => setMixes([]));
  }, [user]);

  const list = (mixes || []).map(withOverrides).filter((m) => m.liked !== false);

  return (
    <main data-testid="favorites-page" className="max-w-[1500px] mx-auto px-4 lg:px-10 pt-32 pb-24">
      <SectionTitle index={<Heart className="inline w-3.5 h-3.5 fill-current" />} kicker={t("favs.kicker")} title={<>{t("favs.title")}<span className="text-[#1FD1FF]">.</span></>}>
        {list.length > 0 && (
          <button data-testid="favorites-play-all-button" onClick={() => playMix(list[0], list)}
            className="flex items-center gap-3 pl-2 pr-6 py-2 bg-[#1FD1FF] text-black font-mono text-sm uppercase tracking-widest hover:bg-white transition-colors">
            <span className="w-10 h-10 bg-black text-[#1FD1FF] grid place-items-center"><Play className="w-4 h-4 fill-current" /></span>{t("favs.playAll")}
          </button>
        )}
      </SectionTitle>

      {user === false && (
        <div data-testid="favorites-login-prompt" className="py-20 text-center border border-dashed border-white/15">
          <p className="text-[#A8B3C4] mb-6">{t("favs.login")}</p>
          <button data-testid="favorites-login-button" onClick={() => openAuth("login")} className="px-6 py-3 bg-[#1FD1FF] text-black font-mono text-sm uppercase tracking-widest">{t("auth.login")}</button>
        </div>
      )}
      {user && mixes && list.length === 0 && (
        <div data-testid="favorites-empty" className="py-20 text-center border border-dashed border-white/15">
          <Heart className="w-10 h-10 mx-auto text-[#1FD1FF] mb-4" />
          <p className="text-[#A8B3C4] mb-6 max-w-sm mx-auto">{t("favs.empty")}</p>
          <Link to="/" data-testid="favorites-browse-link" className="inline-block px-6 py-3 border border-[#1FD1FF] text-[#1FD1FF] font-mono text-sm uppercase tracking-widest hover:bg-[#1FD1FF] hover:text-black transition-colors">{t("favs.browse")}</Link>
        </div>
      )}
      {list.length > 0 && (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-16">
          {list.map((m, i) => <MixCard key={m.id} mix={m} idx={i + 1} list={list} />)}
        </div>
      )}
    </main>
  );
}
